export const API = {
    BASE_URL: {
        DEVELOPMENT: process.env.REACT_APP_API_URL_DEV,
        STAGING: 'https://staging-api.tudominio.com/api',
        PRODUCTION: 'https://api.tudominio.com/api',
    },
};

export const API_VERSION = {
    V1: 'v1',
    V2: 'v2',
    CURRENT: 'v1',
};

export const ENDPOINTS = {
    AUTH: {
        LOGIN: '/auth/login',
        LOGOUT: '/auth/logout',
        REFRESH: '/auth/refresh',
        REGISTER: '/auth/register',
    },
    DRIVERS: {
        BASE: '/drivers',
        DETAILS: (id: string | number) => `/drivers/${id}`,
        SERVICES: (id: string | number) => `/drivers/${id}/services`,
        AVAILABILITY: (id: string | number) => `/drivers/${id}/availability`,
    },
    VEHICLES: {
        BASE: '/vehicles',
        DETAILS: (id: string | number) => `/vehicles/${id}`,
        MAINTENANCE: (id: string | number) => `/vehicles/${id}/maintenance`,
    },
    SERVICES: {
        BASE: '/services',
        DETAILS: (id: string | number) => `/services/${id}`,
        ACTIVE: '/services/active',
        COMPLETED: '/services/completed',
        ASSIGN: (id: string | number) => `/services/${id}/assign`,
    },
    USERS: {
        BASE: '/users',
        PROFILE: '/users/profile',
        PREFERENCES: '/users/preferences',
    },
};

export const HTTP_METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
};

export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    INTERNAL_SERVER_ERROR: 500,
};

export const TIMEOUTS = {
    DEFAULT: 10000,  // 10s
    LONG: 30000,     // 30s
    SHORT: 5000,     // 5s
};

export const HEADERS = {
    CONTENT_TYPE: 'Content-Type',
    AUTHORIZATION: 'Authorization',
    ACCEPT: 'Accept',
};

export const CONTENT_TYPES = {
    JSON: 'application/json',
    FORM_DATA: 'multipart/form-data',
    URL_ENCODED: 'application/x-www-form-urlencoded',
};